import { useCallback, useMemo } from "react";
import { t } from "@/i18n-js/instance";
import { TextSelect } from "@/react/components/shared/TextSelect";
import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import { PARAGRAPH_DEFAULT_DATA, TEXT_SELECT_OPTIONS } from "./constants";
import type { ParagraphStyle } from "./constants";
import { isParagraphBlock } from "./typePredicates";

interface ParagraphLevelPickerProps {
  label: string;
}

export const ParagraphLevelPicker = ({ label }: ParagraphLevelPickerProps) => {
  const data = useBuilderStore(state => state.getSelectedBlock());
  const selectedBlock = data?.block;
  const updateSelectedBlock = useBuilderStore(
    state => state.updateSelectedBlock,
  );

  const isParagraphBlockType = useMemo(
    () => !!selectedBlock && isParagraphBlock(selectedBlock.type),
    [selectedBlock],
  );

  const handleParagraphStyleChange = useCallback(
    (newStyle: ParagraphStyle) => {
      if (!selectedBlock) return;

      const defaultData = PARAGRAPH_DEFAULT_DATA[newStyle];

      updateSelectedBlock({
        ...selectedBlock,
        props: {
          ...selectedBlock.props,
          paragraphStyle: {
            prop: "other",
            type: "paragraph-style-picker",
            value: newStyle,
          },
          styles: defaultData.props.styles,
        },
      });
    },
    [selectedBlock, updateSelectedBlock],
  );

  if (!isParagraphBlockType || !selectedBlock) return null;

  const currentParagraphStyle =
    (selectedBlock.props.paragraphStyle?.value as ParagraphStyle) || "p1";

  return (
    <div>
      <label className="form-group__label text-dark text-xs font-normal">
        {label}
      </label>
      <TextSelect
        options={TEXT_SELECT_OPTIONS}
        value={currentParagraphStyle}
        onChange={handleParagraphStyleChange}
        placeholder={t("builder_ui.prop_type.paragraph_style")}
        buttonClassName="w-full"
      />
    </div>
  );
};
